import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import N_tick from "../../../../src/assets/images/N_tick.png";
import N_wws_warehousing from "../../../assets/images/warehousing_icon.png";
import N_wws_fumigation from "../../../assets/images/fumignation_icon.png";
import N_wws_Quality from "../../../assets/images/quality_icon.png";
import N_wws_Stockpoint from "../../../assets/images/stock.png";
import N_wws_Procurement from "../../../assets/images/feild_icon.png";
import port_icon from "../../../assets/images/port_icon.png";
import N_wws_Export from "../../../assets/images/export_assist_icon.png";
import ServiceContact from "../../../_Pages/_webapp/OurServises/ServiceContact";
import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";

class WweAgriCorporation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "en",
    };
  }
  componentDidMount() {
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
  }
  render() {
    const metaTags = document.getElementsByTagName("meta");
    for (const tag of metaTags)
      if (tag.name === "description")
        tag.content =
          "Arya serves the national and multinational agri corporations to link markets access with farmers and helps them in getting the best prices of their products.";

    return (
      <React.Fragment>
        <SetHeader active={"story"} history={this.props.history}></SetHeader>

        <Helmet>
          <title>
            Who we Serve | National and Multinational Agri Corporations | Arya
          </title>
          <meta
            name="keywords"
            content="Warehouse near me, paddy warehouse, Maize Warehouse, Sugar warehouse, Wheat warehouse, Soyabean warehouse, Rice warehouse, Cotton warehouse, List your warehouse, Buy sell paddy online, Buy sell maize online, Buy sell pulses online, Buy sell spices online, Get loan on agri products, Get loan on agri commodities, Get finance on your commodities, paddy stock near me, maize Stock near me, Wheat stock near me, Bajra Stock near me, Jowar stock near me, Sugar stock near me, Soybean Stock near me, Cotton stock near me, Rice stock near me"
          />
        </Helmet>

        <section className="Whoweservebanner AgriCorp_Banner">
          <Container>
            <Row>
              <Col>
                <div className="wws_banner_portion">
                  <div className="wws_banner_heading">
                    <h1>
                      {localStorage.getItem("warehouseCount")
                        ? localStorage.getItem("warehouseCount") + "+"
                        : "9600+"}
                      <MultiLanguageTranslation title=" Warehouses Across " />
                      {localStorage.getItem("districtCount")
                        ? localStorage.getItem("districtCount") + "+"
                        : "800+"}
                      <MultiLanguageTranslation title=" Locations" />
                    </h1>
                  </div>
                  <div className="wws_banner_heading_content">
                    <a href="/WhoWeServeFPO">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Farmer & FPO" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Processor">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Processors" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Agri_corporation">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Agri Corporations" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Financial">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Financial Institutions" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/InternationalBuyer">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="International Buyers" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/DevelopmentActors">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Development Actors" />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="NA_customBreadcumb">
                <Link onClick={() => this.props.history.push("/")}>
                  <MultiLanguageTranslation title="Arya.ag" />
                </Link>{" "}
                <span>→</span>{" "}
                <Link onClick={() => this.props.history.push("/WhoWeServe")}>
                  <MultiLanguageTranslation title="Who We Serve" />
                </Link>{" "}
                <span>→</span>
                <span className="breadcrumb_active">
                  <MultiLanguageTranslation title="Agri CORPORATIONS" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <section className="N_wws">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="N_wws_heading">
                  <h2>
                    <MultiLanguageTranslation title="Agri CORPORATIONS" />
                  </h2>
                </div>
                <div className="wws_desc">
                  <p>
                    <MultiLanguageTranslation title="agricorporate_page_title_National_and_Multinational_Agri" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="N_wws_offer_por">
          <Container>
            <Row>
              <Col>
                <div className="N_wws_offer">
                  <div className="N_wws_offer_heading">
                    <h4>
                      <MultiLanguageTranslation title="Our Offerings" />
                    </h4>
                  </div>
                  <div className="N_wws_offer_content-sec">
                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_warehousing} />
                      <h5>
                        <MultiLanguageTranslation title="Warehousing" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_fumigation} />
                      <h5>
                        <MultiLanguageTranslation title="Fumigation" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Quality} />
                      <h5>
                        <MultiLanguageTranslation title="Quality Testing & Assaying" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={port_icon} />
                      <h5>
                        <MultiLanguageTranslation title="Port & Rake Handling & Stockpoint Audits" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Stockpoint} />
                      <h5>
                        <MultiLanguageTranslation title="Warehouse & Stockpoint Audits" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Procurement} />
                      <h5>
                        <MultiLanguageTranslation title="On Field Farmer Procurement" />{" "}
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Procurement} />
                      <h5>
                        <MultiLanguageTranslation title="Quality Procurement Assistance & Monitoring" />{" "}
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Export} />
                      <h5>
                        <MultiLanguageTranslation title="Consulting On Post Harvest Value Chain and Farm Linkages" />
                      </h5>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <ServiceContact />

        <section className="formContent">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>
                  <MultiLanguageTranslation title="Looking For The Right Agri Corporations For Help? Let ARYA Be Your Path Shower" />
                </h1>

                <p>
                  <MultiLanguageTranslation title="agri_c_p1" />
                </p>

                <h2>
                  <MultiLanguageTranslation title="We build the bridge to shorten the gap" />{" "}
                </h2>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="agri_c_p2" />
                  ) : (
                    <>
                      ARYA is a well-known name in the industry that offers{" "}
                      <b>Agri corporations</b> to come forward and help the
                      farmers in doing their job. To grow a good amount of
                      product, the farmers need finance, and it is not easy to
                      arrange it. Also, they are not getting the privilege of
                      selling the products that they have harvested at the
                      correct rates.
                    </>
                  )}
                </p>

                <h3>
                  <MultiLanguageTranslation title="ARYA offers the farmers to sell in the international markets" />
                </h3>
                <p>
                  <MultiLanguageTranslation title="agri_c_p3" />
                </p>

                <h4>
                  <MultiLanguageTranslation title="We offer a value chain for the growth of the agricultural sector" />
                </h4>
                <p>
                  <MultiLanguageTranslation title="agri_c_p4" />
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}
export default WweAgriCorporation;
